import { module as ModuleJS } from "modujs";
import { loadScript } from "../utils/loadScript";

window.soYouTubeApiTasks = [];
window.soYoutubeVideoHandlerReady = false;

export default class extends ModuleJS {
    constructor(m) {
        super(m);

        this.cover = this.$("cover") ? this.$("cover")[0] : null;
        // this.player = this.$('player') ? this.$('player')[0] : null;
        // this.iframe = this.el.querySelector("iframe");
        this.iframeLoader = this.$("iframe-loader")
            ? this.$("iframe-loader")[0]
            : null;
        this.code = this.getData("code");
        console.log("this.code", this.code);
    }

    init() {
        this.onCoverClick = this.onCoverClick.bind(this);
        this.initPlayer();
        this.bindEvents();
    }

    onCoverClick(e) {
        e.preventDefault();
        this.el.classList.add("-clicked");
        this.startVideo();
    }

    loadYoutubeAPI(callback) {
        if (!window.YT || (window.YT && !window.YT.loaded)) {
            soYouTubeApiTasks.push(callback);
        } else {
            callback();
        }

        if (!soYoutubeVideoHandlerReady) {
            const oldOnYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady || function() {};

            window.onYouTubeIframeAPIReady = () => {
                oldOnYouTubeIframeAPIReady();
                soYouTubeApiTasks.forEach((task) => task());
            }
            soYoutubeVideoHandlerReady = true;
        }

        if (!window.YT) {
            loadScript("https://www.youtube.com/iframe_api");
        }
    }

    initPlayer() {
        if (!this.player && this.iframeLoader) {
            this.loadYoutubeAPI(() => {
                this.player = new YT.Player(this.iframeLoader, {
                    height: null,
                    width: null,
                    videoId: this.code,
                    onReady: () => {
                        console.log(this);
                        // this.player.mute();
                        // this.player.playVideo();
                    },
                });
                this.iframeLoader = null;
            });
        }
    }

    startVideo() {
        if (!this.player) return;
        this.player.playVideo();
    }

    bindEvents(el) {
        this.cover.addEventListener("click", this.onCoverClick);
    }

    update(newContainer) {
        this.cover.removeEventListener("click", this.onCoverClick);
        this.cover.addEventListener("click", this.onCoverClick);
    }

    destroy(oldContainer) {
        this.cover.removeEventListener("click", this.onCoverClick);
    }
}
